import { usePerms } from 'contexts/PermsContext';
import AlertCreator from 'features/Weather/features/WeatherAlerts/features/AlertCreator/index.web';
import WeatherAlertsWidget from 'features/Weather/features/WeatherAlerts/index.web.widget';

const CreateAlert = ({ widget, dimensions }) => {
  const perms = usePerms();

  if (dimensions?.length && perms.testPermission([8, 9, 10, 11, 12, 13], ['WeatherAlerts'])) {
    return <WeatherAlertsWidget dimensions={dimensions} widget={widget} widgetType="create" />;
  }

  if (perms.testPermission([8, 9, 10, 11, 12, 13], ['WeatherAlerts'])) {
    return <AlertCreator perms={perms} />;
  }
};

export default CreateAlert;
